import styled from 'styled-components'
import { Swiper } from 'swiper/react'

import Modal from '../Modal'
import AdsArchiveForm from '../../forms/AdsArchiveForm'
import SwiperPagination from '../SwiperPagination'

export const ModalStyled = styled(Modal)`
  > div {
    width: 100%;
  }
`

export const SwiperInstance = styled(Swiper)`
  width: 100%;

  .swiper-wrapper {
    align-items: center;
  }
`

export const Form = styled(AdsArchiveForm)`
  margin-top: 2.3rem;
`

export const Item = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4rem;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    flex-direction: column;
  }
`

export const Media = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    width: 100%;
  }
`
export const Content = styled.div`
  width: 45%;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    width: 100%;
  }
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.firaSans3XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  border-bottom: 3px dashed ${({ theme }) => theme.colors.greyContour};
  padding-bottom: 1rem;
  margin-bottom: 3rem;
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.montserratXl};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    ${({ theme }) => theme.textStyles.montserratTextBase};
  }
`

export const Navigation = styled(SwiperPagination)``
